import React, { useState, useEffect } from 'react';
import styled from 'react-emotion';
import SlideDropdown from './SlideDropdown';
import SubPagesQuery from './SubPagesQuery.gql';
import { Query } from 'react-apollo';
import { ParentLink, Placeholder } from '../Layout/CategoryTree';
import { PageList } from '../Layout/LeftAside';
import { Aside } from '../Layout/Layout';
import { withRouter } from 'react-router-dom';

const Subcategories = styled.ul`
  margin-bottom: 20px;
`;

export const CategoryTreeWithSlidedown = withRouter(
  ({ category, location }) => {
    const [open, setOpen] = useState('');
    const { pathname } = location;

    useEffect(() => {
      if (category.primaryRoute && category.primaryRoute.path === pathname) {
        setOpen(category.id);
      }
    }, [category.id, category.primaryRoute, pathname]);

    return (
      <Query query={SubPagesQuery} variables={{ id: 1286 }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Placeholder />;
          }

          return (
            <div>
              <ParentLink category={data.category}>
                {data.category.name}
              </ParentLink>
              <Subcategories>
                {data.category.subcategories.map(subcategory => (
                  <SlideDropdown
                    key={subcategory.id}
                    setOpen={setOpen}
                    open={open}
                    isOpen={subcategory.id === open}
                    category={subcategory}
                  />
                ))}
              </Subcategories>
            </div>
          );
        }}
      </Query>
    );
  }
);

const LeftAsideWithDropdown = ({ category }) => {
  return (
    <Aside>
      <CategoryTreeWithSlidedown category={category} />
      <PageList />
    </Aside>
  );
};

export default LeftAsideWithDropdown;
